export const isCouponTemplateSubtitleParams = (params) => 'coupon' in params;
//# sourceMappingURL=utils.js.map